import { Delete, Edit } from "@mui/icons-material";
import { Box, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

export const roleMap = {
  admin: "Poisum Admin",
  missionCreator: "Mission Creator",
  user: "User",
};

export const genderMap = {
  male: "Male",
  female: "Female",
};

export const departmentMap = {
  hr: "HR",
  it: "IT",
  sales: "Sales",
};

export const jobGradeMap = {
  1: "G1",
  2: "G2",
  3: "G3",
  4: "G4",
  5: "G5",
};

export const userColumns = [
  {
    field: "id",
    headerName: "#",
    width: 50,
    renderCell: (params) => (
      <Link
        to={`/view-user/${params.value}`}
        style={{ color: "#39493F", textDecoration: "underline" }}
      >
        {params.value}
      </Link>
    ),
  },
  {
    field: "employeecode",
    headerName: "Employee Code",
    minWidth: 150,
  },
  {
    field: "fullname",
    headerName: "Full Name",
    minWidth: 200,
    flex: 1,
    renderCell: (params) => (
      <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
        }}
      >
        {params.value}
      </Box>
    ),
  },
  {
    field: "role",
    headerName: "Role",
    minWidth: 150,
    renderCell: (params) => {
      const roleName = roleMap[params.value] || params.value; // fallback if not found
      return (
        <Box
          sx={{
            textTransform: "capitalize",
          }}
        >
          {roleName}
        </Box>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 200,
    flex: 1,
    renderCell: (params) => (
      <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
        }}
      >
        {params.value}
      </Box>
    ),
  },
  {
    field: "gender",
    headerName: "Gender",
    minWidth: 150,
    renderCell: (params) => {
      const genderName = genderMap[params.value] || params.value; // fallback if not found
      return (
        <Box
          sx={{
            textTransform: "capitalize",
          }}
        >
          {genderName}
        </Box>
      );
    },
  },
  {
    field: "dob",
    headerName: "Date of Birth",
    minWidth: 150,
    flex: 1,

  },
  {
    field: "designation",
    headerName: "Designation",
    minWidth: 150,
  },
  {
    field: "department",
    headerName: "Department",
    minWidth: 150,
    renderCell: (params) => {
      const departName = departmentMap[params.value] || params.value; // fallback if not found
      return (
        <Box
          sx={{
            textTransform: "capitalize",
          }}
        >
          {departName}
        </Box>
      );
    },
  },
  {
    field: "jobgrade",
    headerName: "Job Grade",
    minWidth: 150,
    renderCell: (params) => {
      const jobGrade = jobGradeMap[params.value] || params.value; // fallback if not found
      return (
        <Box
          sx={{
            textTransform: "capitalize",
          }}
        >
          {jobGrade}
        </Box>
      );
    },
  },
   {
      field: "Actions",
      headerName: "Actions",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <Link>
          <IconButton sx={{color:"#39493F"}} onClick={() => console.log(params.row.id)}>
            <Tooltip title="Edit" placement="right">
              <Edit />
            </Tooltip>
          </IconButton>
        </Link>,
        <Link>
          <IconButton sx={{color:"#39493F"}}>
            <Tooltip title="Delete" placement="right">
              <Delete />
            </Tooltip>
          </IconButton>
        </Link>,
      ],
    },
];
